import { DOCUMENT_UPLOAD_RESULT, LENDER_ADD_PHASE_INFO, LENDER_ADD_PROJECT_INFO, REQUEST_ID_RESULT, REQUEST_TYPE_ID_RESULT, RESET_LENDER_REQUEST, RESET_LENDER_REQUEST_PHASE_INFO, RESET_LENDER_REQUEST_PROJECT_INFO, SET_ALL_DOC_TYPES_BY_ID, SET_DOC_TYPES_BY_FIELD, SET_DOCUMENT_RANKING_ID_TO_REQUEST_SUBTYPE_DOC_ID_MAP, SET_EDITING_CHANGES, SET_OPTIONAL_DOCUMENTS, SET_PHASE_FIELDS_MAP, SET_PROJECT_FIELDS_MAP, SET_REASON_CODES_TO_REQUEST_SUBTYPES, SET_REQUEST_STATUSES, SET_REQUEST_SUBTYPE_LOOKUP, SET_REQUEST_SUBTYPE_TO_DOCUMENT_JUNCTION, SET_REQUEST_SUBTYPES, SET_REQUEST_TYPE_NAME, SET_REQUIRED_DOCUMENTS, SET_REQUIRED_DOCUMENTS_WITH_COUNT } from "../actions/ActionType";

function initialProjectInfo() {
  return {
    type: "",
    userName: "",
    phaseName: "",
    alternativeName: "",
    styleComments: "",
    HOAtaxid: "",
    HOAname: "",
    MAname: "",
    streetAddress: "",
    units: "",
    city: "",
    zip: "",
    style: "",
    state: "",
    zip5: "",
    HOAtaxid: "",
    conveyedUnits: "",
    isProjectComplete: "",
    isProjectSubjectToAddPhase: "",
    isProjectHOATurnoverOwner: "",
    hasDeveloperOwnedUnits: "",
    developerOwnedUnits: "",
    comments: ""
  };
} 

function initialPhaseInfo() {
  return {
    projectId: "",
    phaseId: null,
    phaseName: "",
    street: "",
    buildingNumber: "",
    unitNumber: "",
    unitCount: ""
  };
}

function initialState() {
  return {
    requestId: null,
    requestTypeName: "",
    requestTypeId: null,
    requestSubTypes: [],
    requestSubTypeLookup: null,
    docMapIds: [],
    requiredDocsByFieldName: {},
    editingChanges: null,
    projectInfo: initialProjectInfo(),
    phaseInfo: initialPhaseInfo(),
    requiredDocTypes: null,
    requiredDocTypesWithCount: [],
    optionalDocTypes: null,
    requiredDocsByFieldLookup: {},
    // TODO: select project or phase field defs during initLenderRequest based on request type
    projectFieldsMap: new Map(),
    phaseFieldsMap: new Map(),
    allDocTypesById: new Map(),
    requestStatuses: [],
    reasonCodeToRequestSubTypeLookup: new Map(),
    
    // note: this name is a mouthful, but it's the only way to describe what this is for.
    // the API might return multiple requestSubTypeDocIds for a single document type, so we 
    // need to track them all for later when we save the attachments.
    documentToRequestSubTypeJunction: new Map(),
    requestSubTypeToDocumentJunction: new Map()
  };
};

export const lenderRequestReducer = (currentState = initialState(), action) => {
  switch (action.type) {
    case RESET_LENDER_REQUEST:
      return {
        ...initialState()
      };
    case RESET_LENDER_REQUEST_PROJECT_INFO:
      return {
        ...currentState,
        projectInfo: initialProjectInfo()
      };
    case RESET_LENDER_REQUEST_PHASE_INFO:
      return {
        ...currentState,
        phaseInfo: initialPhaseInfo()
      };
    case SET_DOC_TYPES_BY_FIELD:
      return { 
        ...currentState, 
        requiredDocsByFieldName: action.payload 
      };
    case LENDER_ADD_PROJECT_INFO:
      return {
        ...currentState,
        projectInfo: action.payload
      };
    case LENDER_ADD_PHASE_INFO:
      return {
        ...currentState,
        phaseInfo: action.payload
      };
    case REQUEST_ID_RESULT: 
      return {
        ...currentState,
        requestId: action.payload
      };
    case SET_REQUEST_TYPE_NAME: 
      return {
        ...currentState,
        requestTypeName: action.payload
      };
    case REQUEST_TYPE_ID_RESULT:
      return {
        ...currentState,
        requestTypeId: action.payload
      };
    case SET_REQUEST_SUBTYPES:
      return {
        ...currentState,
        requestSubTypes: action.payload
      };    
    case SET_REQUEST_SUBTYPE_LOOKUP:
      return {
        ...currentState,
        requestSubTypeLookup: action.payload
      };
    case SET_REASON_CODES_TO_REQUEST_SUBTYPES:
      return {
        ...currentState,
        reasonCodeToRequestSubTypeLookup: action.payload
      };
    case SET_DOCUMENT_RANKING_ID_TO_REQUEST_SUBTYPE_DOC_ID_MAP:
      return {
        ...currentState,
        documentToRequestSubTypeJunction: action.payload
      };
    case SET_REQUEST_SUBTYPE_TO_DOCUMENT_JUNCTION:
      return {
        ...currentState,
        requestSubTypeToDocumentJunction: action.payload
      };
    case DOCUMENT_UPLOAD_RESULT:
      return {
        ...currentState,
        docMapIds: [
          ...currentState.docMapIds,
          action.payload
        ]
      };
    case SET_REQUIRED_DOCUMENTS:
      return {
        ...currentState,
        requiredDocTypes: action.payload
      };
    case SET_REQUIRED_DOCUMENTS_WITH_COUNT:
      return {
        ...currentState,
        requiredDocTypesWithCount: action.payload
      };
    case SET_OPTIONAL_DOCUMENTS:
      return {
        ...currentState,
        optionalDocTypes: action.payload
      };
    case SET_EDITING_CHANGES:
      return {
        ...currentState,
        editingChanges: action.payload
      };
    // TODO: select project or phase field defs during initLenderRequest based on request type
    case SET_PROJECT_FIELDS_MAP:
      return {
        ...currentState,
        projectFieldsMap: action.payload
      }    
    // TODO: select project or phase field defs during initLenderRequest based on request type
    case SET_PHASE_FIELDS_MAP:
      return {
        ...currentState,
        phaseFieldsMap: action.payload
      }
    case SET_ALL_DOC_TYPES_BY_ID:
      return {
        ...currentState,
        allDocTypesById: action.payload
      };
    case SET_REQUEST_STATUSES:
      return {
        ...currentState,
        requestStatuses: action.payload
      };
    default:
      return currentState;
  }
}
